import types from "../types";
import { copy, Notification, url_encode } from "../../utils";
import backend from "../../api"
import { global_actions } from "../"

const init_wishlist_from_local_storage = () => (dispatch, getState) => {
	dispatch({
		type: types.WISHLIST,
		payload: JSON.parse(localStorage.getItem("wishlist"))
	})
}

const add_to_wishlist = ({ product = null, member_user = null, quantity = 1 } ) => (dispatch, getState) => {
	const { user: user_state } = getState().auth
	let state = copy(getState().wishlist_)
	const status = new Notification()
	const wishlist_unit = { product: product._id, quantity }
	const wishlist_local_unit = { product, quantity }
	if (member_user) {
		wishlist_unit.member_user = member_user
		wishlist_local_unit.member_user = member_user
	}
	let alreadyExistingItem = state.items ? state.items.find(item => item.product._id === product._id) : null
	if (!alreadyExistingItem) {
		if (user_state) {
			dispatch(global_actions.loading(true))
			backend.post(`/favorite/${state._id}/unit`,
				wishlist_unit,
				{
					params: {
						populate: url_encode([
							{ path: "items", populate: [{ path: "product" }] }])
					}
				})
				.then(({ data }) => {
					state = data.data
					status.set_toast("success", data.message)
				})
				.catch(error => {
					status.set_toast("error", error.response ? error.response.data.message : error.message)
				})
				.finally(() => {
					dispatch({
						type: types.WISHLIST,
						payload: state
					})
					dispatch(global_actions.loading(false))
					status.show_toast()
				})
		} else {
			state = {
				items: state.items ? state.items.concat(wishlist_local_unit) : [wishlist_local_unit]
			}
			status.set_toast("success", "Item added to Favorites")
			dispatch({
				type: types.WISHLIST,
				payload: state
			})
			localStorage.setItem("wishlist", JSON.stringify(state))
			status.show_toast()
		}
	} else {
		const status = new Notification()
		status.set_toast("info", "Item already in Wishlist")
		status.show_toast()
	}

}


const remove_from_wishlist = ({ unit = null, product = null } = {}) => (dispatch, getState) => {
	const { user: user_state } = getState().auth
	let state = copy(getState().wishlist_)
	const status = new Notification()
	if (user_state) {
		dispatch(global_actions.loading(true))
		backend.delete(`/favorite/${state._id}/unit/${unit._id}`,
			{
				params: {
					populate: url_encode([
						{ path: "items", populate: [{ path: "product" }] }])
				}
			})
			.then(({ data }) => {
				state.items = state.items.filter(c => c.product._id !== unit.product._id)
				status.set_toast("success", data.message)
			})
			.catch(error => {
				status.set_toast("error", error.response ? error.response.data.message : error.message)
			})
			.finally(() => {
				dispatch({
					type: types.WISHLIST,
					payload: state
				})
				dispatch(global_actions.loading(false))
				status.show_toast()
			})
	} else {
		state = {
			items: state.items.filter(c => c.product._id !== product._id)
		}
		status.set_toast("info", "Item removed from Favorites")
		dispatch({
			type: types.WISHLIST,
			payload: state
		})
		localStorage.setItem("wishlist", JSON.stringify(state))
		status.show_toast()
	}
}

export default { init_wishlist_from_local_storage, add_to_wishlist, remove_from_wishlist }